import styles from './Salary.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RefineRadio from '../RefineRadio/RefineRadio';
import SalaryType from '../SalaryType/SalaryType';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import {
  optimisticUpdateSalaryMaxClicked,
  optimisticUpdateSalaryMinClicked
} from 'src/store/search/optimistic/refinement';

function getOptimisticUpdateHandler(label) {
  return label === 'Maximum'
    ? optimisticUpdateSalaryMaxClicked
    : optimisticUpdateSalaryMinClicked;
}

export default class Salary extends Component {
  static propTypes = {
    handleSelection: PropTypes.func.isRequired,
    salaries: PropTypes.array.isRequired,
    salaryTypes: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired
  };

  shouldComponentUpdate({ active }) {
    return active;
  }

  render() {
    const { handleSelection, salaries, salaryTypes, label } = this.props;
    const id = `refineSalary${label}`;

    return (
      <nav role="navigation" aria-labelledby={id} className={styles.root}>
        <ScreenReaderOnly>
          <h1 id={id}>{`${label} salary`}</h1>
        </ScreenReaderOnly>
        <RefineRadio
          handleSelection={handleSelection}
          preNavigationAction={getOptimisticUpdateHandler(label)}
          labelledBy={id}
          options={salaries}
          path="/jobs"
          data-automation={id}
        />
        <SalaryType
          data-automation={`${id}SalaryType`}
          salaryTypes={salaryTypes}
          className={styles.types}
        />
      </nav>
    );
  }
}
